<template>
    <b-modal
        v-model="modal"
        :title="isEdit ? 'Edit' : 'Add'"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <b-form @submit.prevent="onSubmit">
            <b-form-group label="Dealername">
                <b-form-input
                    v-model="form.dealername"
                    required
                    maxlength="64"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="accounts">
                <b-form-tags v-model="form.accounts" required></b-form-tags>
            </b-form-group>
            <b-button type="submit" block variant="primary">Save</b-button>
        </b-form>
    </b-modal>
</template>

<script>
import { addDealer, editDealer } from '@/services/aws.service';

const INIT_FORM_DATA = {
    dealername: null,
    accounts: [],
};
export default {
    name: 'DealerAddOrEditModal',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        currentData: {
            type: [Object, null],
            required: false,
            default() {
                return null;
            },
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isEdit() {
            return !!this.currentData;
        },
    },
    data() {
        return {
            form: {
                ...INIT_FORM_DATA,
            },
        };
    },
    methods: {
        setData() {
            if (this.isEdit) {
                console.log('sfsdf');
                console.log(this.currentData);
                this.form.dealername = this.currentData.dealername;
                this.form.accounts = this.currentData.accounts;
            }
        },
        resetData() {
            this.form = { ...INIT_FORM_DATA };
        },
        onSubmit() {
            const saveFunc = this.isEdit ? this.editData : this.addData;
            saveFunc()
                .then(() => {
                    this.$bvToast.toast(`Save success!`, {
                        title: 'Success',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'success',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                    this.$emit('onDone');
                    this.modal = false;
                })
                .catch((e) => {
                    const data = e.response?.data || {};

                    this.form.isCreateNewUser = !data.isCreatedUser;
                    const message = data.message || 'An error occurred!';
                    this.$bvToast.toast(message, {
                        title: 'Error',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: 'danger',
                        solid: false,
                        toaster: 'b-toaster-top-center',
                    });
                });
        },
        async addData() {
            return addDealer(this.form);
        },
        async editData() {
            return editDealer(this.currentData.id, this.form);
        },
    },
};
</script>

<style scoped></style>
